import AddIcon from "@mui/icons-material/Add";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CachedIcon from "@mui/icons-material/Cached";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import RemoveIcon from "@mui/icons-material/Remove";
import SellIcon from "@mui/icons-material/Sell";
import { saveAs } from "file-saver";
import Cookies from "js-cookie";
import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import { IoMdArrowDropright } from "react-icons/io";
import { Modal } from "react-responsive-modal";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import ClipLoader from "react-spinners/ClipLoader";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { adjustTextColor } from "../../../utils/helper";

const Task = () => {
  const { baseUrl, openToast } = useGlobalContext();
  const [sortby, setSortBy] = useState("status");
  const [showAllMembers, setShowAllMembers] = useState(false);
  const [showAllTags, setShowAllTags] = useState(false);

  const navigate = useNavigate();

  const [selectedTasks, setSelectedTasks] = useState([]);
  const [massDelete, setMassDelete] = useState(false);

  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV();
    else if (exportFormat === "PDF") exportPDF();
    else if (exportFormat === "Print") printDepartments();
  };
  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };
  const exportCSV = () => {
    const csvData = departments
      .map((dep) => `${dep.department_name}, Total Users: 1`)
      .join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "departments.csv");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Department List", 20, 10);
    departments.forEach((dep, index) => {
      doc.text(
        `${index + 1}. ${dep.department_name} (Total Users: 1)`,
        10,
        20 + index * 10
      );
    });
    doc.save("departments.pdf");
  };
  const handleMassDelete = () => {
    setMassDelete(!massDelete);
    if (!massDelete) {
      const allTasks = allTaskStatus.flatMap((status) =>
        status.TaskDetail.map((task) => ({
          value: task.id,
          label: task.taskName,
        }))
      );
      setSelectedTasks(allTasks);
    } else {
      setSelectedTasks([]);
    }
  };

  const toggleAccordion = (id) => {
    if (isOpen === id) {
      setIsOpen(null);
      return;
    }
    setIsOpen(id);
  };
  const [open8, setOpen8] = useState(false);

  const onOpenModal8 = () => setOpen8(true);
  const onCloseModal8 = () => setOpen8(false);

  const printDepartments = () => {
    const printContent = departments
      .map((dep) => `${dep.department_name} (Total Users: 1)`)
      .join("\n");
    const newWindow = window.open();
    newWindow.document.write(`<pre>${printContent}</pre>`);
    newWindow.document.close();
    newWindow.print();
  };

  const [isOpen, setIsOpen] = useState(null);

  const [exportFormat, setExportFormat] = useState("");

  const [rowsToShow, setRowsToShow] = useState(25);
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F5F9",
      borderColor: "#E2E8F0",
      minHeight: "38px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#E2E8F0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "14px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#4A5568",
      ":hover": {
        backgroundColor: "#CBD5E0",
        color: "#2D3748",
      },
    }),
  };

  const [isLoading, setIsLoading] = useState(false);
  const addNewDiv = () => {
    setDivs([...divs, {}]); // Add a new empty object to the state array
  };

  const [divs, setDivs] = useState([{}]); // Start with one empty object
  const removeDiv = (indexToRemove) => {
    setDivs(divs.filter((_, index) => index !== indexToRemove)); // Filter out the div with the given index
  };
  const [open10, setOpen10] = useState(false);

  const onOpenModal10 = () => setOpen10(true);
  const onCloseModal10 = () => setOpen10(false);

  const [allTaskStatus, setAllTaskStatus] = useState();
  const fetchAllTaskStatus = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(baseUrl + "task/status", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (response.status === 200) {
        const data = await response.json();
        setAllTaskStatus(data.taskStatus);
      } else {
        const error = await response.json();
        console.error(error.message || `HTTP Error: ${response.status}`);
        setAllTaskStatus([]);
      }
    } catch (error) {
      console.error("Error fetching task status:", error);
      setAllTaskStatus([]);
    } finally {
      setIsLoading(false);
    }
  };

  const [departments, setDepartments] = useState([]);
  const fetchDepartments = async () => {
    try {
      const result = await fetch(baseUrl + "department", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status == 200) {
        const res = await result.json();
        setDepartments(res.data);
      } else {
        console.error("Error fetching departments:", result.status);
        setDepartments([]);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      setDepartments([]);
    }
  };

  const [taskPriority, setTaskPriority] = useState([]);
  const fetchTaskPriority = async () => {
    setIsLoading(true);
    try {
      const result = await fetch(baseUrl + "task/priority", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status == 200) {
        const res = await result.json();
        console.log("----------", res);
        setTaskPriority(res.taskPriority);
      } else {
        const error = await result.json();
        console.log(error.message, "error");
        setTaskPriority([]);
      }
    } catch (error) {
      console.log("error", error);
      setTaskPriority([]);
    } finally {
      setIsLoading(false);
    }
  };

  const [projectDetails, setProjectDetails] = useState([]);
  async function fetchProjectDetails() {
    try {
      const result = await fetch(baseUrl + "project", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status == 200) {
        const res = await result.json();
        setProjectDetails(res.data);
      } else {
        console.error("Error fetching projects:", result.status);
        setProjectDetails([]);
      }
    } catch (error) {
      openToast("Error fetching Projects", "error");
      setProjectDetails([]);
    }
  }

  let subtitle;

  const [modalIsOpen2, setIsOpen2] = React.useState(false);
  function openModal2() {
    setIsOpen2(true);
  }
  function afterOpenModal2() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal2() {
    setIsOpen2(false);
  }
  const [selectedTaskData, setSelectedTaskData] = useState();
  const [updateData, setUpdateData] = useState();

  useEffect(() => {
    if (selectedTaskData) {
      setUpdateData(selectedTaskData); // Automatically copy the data to updateData
    }
  }, [selectedTaskData]);

  const [updateTaskName, setUpdateTaskName] = useState();
  const [updateTaskStatus, setUpdateTaskStatus] = useState(
    selectedTaskData?.taskStatusId || ""
  );
  const [updateStartDate, setUpdateStartDate] = useState();
  const [updateEndDate, setUpdateEndDate] = useState();
  const [updateDueDate, setUpdateDueDate] = useState();
  const [updateSelectProject, setUpdateSelectProject] = useState(
    selectedTaskData?.selectProjectId || ""
  );
  const [updateDepartment, setUpdateDepartment] = useState();
  const [updateTaskPriority, setUpdateTaskPriority] = useState(
    selectedTaskData?.taskPriorityId || ""
  );
  const [updateTaskAssigne, setUpdateTaskAssigne] = useState([]);
  const [updateTaskDescription, setUpdateTaskDescription] = useState();
  const [updateTaskTag, setUpdateTaskTag] = useState();
  const [updateTaskAttachFile, setUpdateTaskAttachFile] = useState();

  useEffect(() => {
    setUpdateTaskStatus(selectedTaskData?.taskStatusId || "");
    setUpdateSelectProject(selectedTaskData?.selectProjectId || "");
    setUpdateTaskPriority(selectedTaskData?.taskPriorityId || "");
  }, [selectedTaskData]);

  async function updateDataTaskDetails() {
    const taskId = selectedTaskData?.id; // Get the task ID dynamically from `selectedTaskData`
    const result = await fetch(baseUrl + `task/detail/${taskId}`, {
      method: "PUT",
      headers: {
        "Content-type": "application/form-data",
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
      body: JSON.stringify({
        taskName: updateTaskName,
        startDate: updateStartDate,
        endDate: updateEndDate,
        dueDate: updateDueDate,
        selectProjectId: updateSelectProject,
        taskDescription: updateTaskDescription,
        taskTag: updateTaskTag,
        attachFile: updateTaskAttachFile,
        selectDepartmentId: updateDepartment,
        taskStatusId: updateTaskStatus,
        taskPriorityId: updateTaskPriority,
        taskAssign: updateTaskAssigne,
      }),
    });
    const data = await result.json();
    if ((result.status = 200)) {
      console.log(data);
      openToast(data.message, "success");
    } else {
      openToast(data.message, "error");
    }
  }

  console.log(selectedTaskData);
  async function deleteTask() {
    try {
      const result = await fetch(
        baseUrl + `task/detail/${selectedTaskData?.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );

      const data = await result.json();
      if (result.status === 200) {
        openToast(data.message, "success");
      } else {
        openToast(data.message, "error");
      }
    } catch (error) {
      console.error("Error deleting task:", error);
      openToast("An error occurred while deleting the task", "error");
    } finally {
      onCloseModal8();
      fetchAllTaskStatus();
      fetchDepartments();
      fetchTaskPriority();
      fetchProjectDetails();
    }
  }

  const handleSelectChangeBulk = (selectedOptions) => {
    setSelectedTasks(selectedOptions || []);
  };

  const deleteTasksBulk = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${baseUrl}task/detail/bulk`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          taskIds: selectedTasks.map(({ value }) => value),
        }),
      });

      if (response.ok) {
        const result = await response.json();
        openToast("Tasks deleted successfully");
        onCloseModal();
        fetchAllTaskStatus();
      }
    } catch (error) {
      console.error("Failed to delete tasks:", error);
      openToast("Failed to delete tasks", "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllTaskStatus();
    fetchDepartments();
    fetchTaskPriority();
    fetchProjectDetails();
  }, []);
  return (
    <div className="px-4 py-6 w-full">
      <div className="mb-[20px] w-[108px]">
        {/* Button to open the modal */}
        <Link
          to="/taskform"
          className="flex items-center gap-[4px] allcrm-btn p-[8px] text-[14px] focus-visible:outline-none"
        >
          <AddIcon className="newadd" /> New Task
        </Link>

        {/* Modal */}
      </div>

      <div className="border-[#e5e7eb] bg-white shadow-cs p-[20px] border rounded-lg">
        <h2 className="flex items-center gap-[6px] mb-[10px] font-medium">
          {" "}
          <LibraryBooksIcon />
          Task
        </h2>
        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 mb-3">
          <div className="flex sm:flex-row flex-col flex-wrap items-center gap-2 w-full">
            <select
              onChange={handleSelectChange}
              className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md w-full sm:w-[60px] text-[14px] focus:outline-none"
            >
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="120">120</option>
            </select>
            <select
              onChange={(e) => setExportFormat(e.target.value)}
              className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md w-full sm:w-[67px] text-[14px] focus:outline-none"
            >
              <option value="CSV">CSV</option>
              <option value="PDF">PDF</option>
              <option value="Print">Print</option>
            </select>

            <button
              onClick={handleExport}
              className="bg-[#27004a] p-[7px] rounded-md w-full text-nowrap sm:w-[83px] text-[14px] text-white cursor-pointer"
            >
              Export File
            </button>
            <button
              className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-lg w-full sm:w-[123px] text-[14px]"
              onClick={onOpenModal}
            >
              Bulk Action <CachedIcon className="newsidebar-icon" />{" "}
            </button>
          </div>

          <div className="relative flex flex-wrap justify-end items-center gap-2 w-full">
            <label htmlFor="">Sort by:</label>
            <select
              value={sortby}
              onChange={(e) => setSortBy(e.target.value)}
              className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md text-[14px] focus:outline-none"
            >
              <option value="status">Task Status</option>
              <option value="priority">Task Priority</option>
            </select>
          </div>
        </div>
        {isLoading && (
          <div className="flex justify-center items-center py-12 w-full">
            <tr className="h-[100px]">
              <td
                colSpan="13"
                className="border-[#dbdbdb] py-4 font-semibold text-center text-gray-600 text-xl whitespace-nowrap"
              >
                <ClipLoader color="#27004a" size={40} />
              </td>
            </tr>
          </div>
        )}
        {!isLoading && sortby === "status" && allTaskStatus?.length === 0 && (
          <div className="flex justify-center items-center py-12 w-full">
            <tr className="h-[100px]">
              <td
                colSpan="13"
                className="border-[#dbdbdb] py-4 font-semibold text-center text-red-600 text-md whitespace-nowrap"
              >
                No Task Found
              </td>
            </tr>
          </div>
        )}
        {!isLoading && sortby !== "status" && taskPriority?.length === 0 && (
          <div className="flex justify-center items-center py-12 w-full">
            <tr className="h-[100px]">
              <td
                colSpan="13"
                className="border-[#dbdbdb] py-4 font-semibold text-center text-red-600 text-md whitespace-nowrap"
              >
                No Task Found
              </td>
            </tr>
          </div>
        )}

        {!isLoading && (
          <>
            {(sortby === "status" ? allTaskStatus : taskPriority)?.map(
              (item, index) => (
                <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-full overflow-x-auto mb-3">
                  <table className="border-[#dcdbdb] border-collapse border rounded-lg w-full overflow-hidden table-auto">
                    {/* Table Header - Acts as Toggle Button */}
                    {/* <* Table Body - Collapsible Content */}

                    <thead
                      className="border-gray-300 shadow-md border cursor-pointer"
                      onClick={() => toggleAccordion(item.id)}
                    >
                      <tr>
                        <th className="flex justify-center items-center p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          <IoMdArrowDropright
                            className={`text-[20px] transition-transform duration-200 ${
                              isOpen === item.id
                                ? "rotate-90 text-[black]"
                                : "rotate-0"
                            }`}
                          />
                          <button
                            className=" mr-[7px] p-[6px] rounded-lg"
                            style={{
                              color: adjustTextColor(
                                item.statusColor || "#000  "
                              ),
                              backgroundColor: item.statusColor || "#000",
                            }}
                          >
                            {item.taskStatusName || item.taskPriorityName}
                          </button>
                          <span className="six-north">
                            {item?.TaskDetail?.length}
                          </span>
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Name
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Status
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Start Date
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          End Date
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Due Date
                        </th>

                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Select Project
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Select Department
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Priority
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Assignee
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Description
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Tag
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Task Image
                        </th>
                        <th className="p-2 border-r font-medium text-center text-xs whitespace-nowrap">
                          Action
                        </th>
                      </tr>
                    </thead>
                    {isOpen === item.id && (
                      <tbody
                        className={`transition-body ${
                          isOpen === item.id ? "open" : ""
                        }`}
                      >
                        {item?.TaskDetail?.map((s, index) => (
                          <tr
                            key={index}
                            className="border-[#e5e7eb] border-b rounded-lg"
                          >
                            <td className="border-[#dbdbdb]  p-2 border-r min-w-[60px] font-medium text-[12px] text-center">
                              {index + 1}
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[150px] font-medium text-[12px] text-center whitespace-nowrap">
                              <Link to="#" className="textcomplete">
                                {s.taskName}
                              </Link>
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[120px] font-medium text-[12px] text-center whitespace-nowrap">
                              {item.taskStatusName}
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[120px] font-medium text-[12px] text-center whitespace-nowrap">
                              {s.startDate}
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[120px] font-medium text-[12px] text-center whitespace-nowrap">
                              {s.endDate}
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[120px] font-medium text-[12px] text-center whitespace-nowrap">
                              {s.dueDate}
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[100px] font-medium text-[12px] text-center whitespace-nowrap">
                              {/* <button className="border-[#dbdbdb] bg-[#c4bfbf] p-[6px] border-r rounded-lg text-white">
                          N/A
                        </button> */}
                              {s?.Project?.project_name || "N/A"}
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[80px] font-medium text-[12px] text-center">
                              {s?.department?.department_name || "N/A"}
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[100px] font-medium text-[12px] text-center whitespace-nowrap">
                              {s?.taskPriority?.taskPriorityName || "N/A"}
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[100px] font-medium text-[12px] text-center whitespace-nowrap">
                              <div className="flex flex-col gap-1">
                                {(() => {
                                  const groupedStaff = [];
                                  for (
                                    let i = 0;
                                    i < s?.taskAssignee?.length;
                                    i += 3
                                  ) {
                                    groupedStaff.push(
                                      s?.taskAssignee?.slice(i, i + 3)
                                    );
                                  }
                                  return (
                                    <>
                                      {groupedStaff
                                        ?.slice(
                                          0,
                                          showAllMembers
                                            ? groupedStaff.length
                                            : 1
                                        )
                                        ?.map((group, groupIndex) => (
                                          <div
                                            key={groupIndex}
                                            className="flex justify-center space-x-2"
                                          >
                                            {group.map((item, i) => (
                                              <span
                                                key={item.id}
                                                className="mr-2 p-1 border rounded-md text-[12px]"
                                              >
                                                {item?.User?.name}
                                              </span>
                                            ))}
                                          </div>
                                        ))}
                                    </>
                                  );
                                })()}
                                {s?.taskAssignee?.length > 3 && (
                                  <button
                                    onClick={() =>
                                      setShowAllMembers(!showAllMembers)
                                    }
                                    className="text-[#27004a] font-bold text-2xl"
                                  >
                                    ...
                                  </button>
                                )}
                              </div>
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[100px] text-wrap text-ellipsis font-medium text-[12px] text-center whitespace-nowrap">
                              {s?.taskDescription || "N/A"}
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[100px] font-medium text-[12px] text-center whitespace-nowrap">
                              <div className="flex flex-col gap-1">
                                {(() => {
                                  const groupedTags = [];
                                  for (
                                    let i = 0;
                                    i < s?.taskTag?.length;
                                    i += 3
                                  ) {
                                    groupedTags.push(s.taskTag.slice(i, i + 3));
                                  }
                                  return (
                                    <>
                                      {s.taskTag.length === 0 && (
                                        <span className="mr-2 p-1 border rounded-md text-[12px]">
                                          N/A
                                        </span>
                                      )}
                                      {groupedTags
                                        ?.slice(
                                          0,
                                          showAllTags ? groupedTags.length : 1
                                        )
                                        .map((group, groupIndex) => (
                                          <div
                                            key={groupIndex}
                                            className="flex justify-center space-x-2"
                                          >
                                            {group.map((tag, i) => (
                                              <span
                                                key={i}
                                                className="mr-2 p-1 border rounded-md text-[12px]"
                                              >
                                                {tag}
                                              </span>
                                            ))}
                                          </div>
                                        ))}
                                    </>
                                  );
                                })()}
                                {s?.taskTag?.length > 3 && (
                                  <button
                                    onClick={() => setShowAllTags(!showAllTags)}
                                    className="text-[#27004a] font-bold text-2xl"
                                  >
                                    ...
                                  </button>
                                )}
                              </div>
                            </td>
                            <td className="border-[#dbdbdb] p-2 border-r min-w-[100px] font-medium text-[12px] text-center whitespace-nowrap">
                              {s?.attachFile?.length === 0
                                ? "N/A"
                                : s?.attachFile?.map((s) => (
                                    <img
                                      src={s || "/placeholder.svg"}
                                      alt="Task file"
                                      key={s}
                                      className="w-20 h-10 rounded-lg object-cover object-center my-2"
                                    />
                                  ))}
                            </td>
                            <td className="flex justify-center gap-2 p-2">
                              <button
                                onClick={() => {
                                  navigate("/edittask", { state: s });
                                }}
                              >
                                <BorderColorIcon />
                              </button>

                              <div>
                                <button
                                  onClick={() => {
                                    // setDeleteClient(item.id);
                                    console.log(s);
                                    setSelectedTaskData(s);
                                    onOpenModal8();
                                  }}
                                >
                                  <DeleteIcon className="text-red-500 cursor-pointer" />
                                </button>
                                <Modal
                                  open={open8}
                                  onClose={onCloseModal8}
                                  center
                                >
                                  <div className="flex justify-center items-center h-[120px]">
                                    <h2 className="font-medium text-[#27004a] text-[18px] text-center">
                                      Are you sure want to delete this
                                    </h2>
                                  </div>
                                  <div className="flex justify-around items-center">
                                    <button
                                      className="allcrm-btn"
                                      onClick={() => {
                                        deleteTask();
                                      }}
                                    >
                                      Yes , Confirm
                                    </button>
                                    <button
                                      className="allcrm-btn"
                                      onClick={() => setOpen8(false)}
                                    >
                                      No , Cancel
                                    </button>
                                  </div>
                                </Modal>
                              </div>
                            </td>
                          </tr>
                        ))}
                        {item.TaskDetail.length === 0 && (
                          <tr>
                            <td colSpan="13" className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
              )
            )}
          </>
        )}
        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[10px] pb-[0] w-[100%]">
          <p className="text-[#a5a1a1] text-[14px]">
            Showing 1 to {rowsToShow} of {departments.length} entries
          </p>
          <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
            <Link to="#" className="pt-2 pb-[8px] text-[12px]">
              Previous
            </Link>
            <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">
              1
            </span>
            <Link to="#" className="pt-2 pb-[8px] text-[12px]">
              Next
            </Link>
          </div>
        </div>

        {/* onclick Update task */}
        <Modal
          isOpen={modalIsOpen2}
          onAfterOpen={afterOpenModal2}
          onRequestClose={closeModal2}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="shadow p-3 border-b-1 text-[13px] xl:text-[15px]"
          >
            Update Task
          </h2>
          <button
            onClick={closeModal2}
            className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="">
            <div className="relative bg-white p-6 h-[400px] overflow-y-scroll">
              <div className="w-[100%]">
                <div className="w-[100%]">
                  <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                    Task Name
                  </label>
                  <br />
                  <input
                    type="text"
                    onChange={(e) => setUpdateTaskName(e.target.value)}
                    defaultValue={updateData?.taskName}
                    className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  />{" "}
                  <br />
                </div>
                <div className="flex gap-[8px]">
                  <div className="w-[100%]">
                    <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                      Task Status
                    </label>{" "}
                    <br />
                    <select
                      onChange={(e) => setUpdateTaskStatus(e.target.value)} // Set the selected task status ID
                      value={updateTaskStatus} // Set current state as the value to stay in sync
                      className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                    >
                      <option value="">Please Select Task Status</option>
                      {allTaskStatus?.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.taskStatusName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="flex gap-[8px]">
                  <div className="w-[50%]">
                    <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                      Start Date
                    </label>{" "}
                    <br />
                    <input
                      type="date"
                      onChange={(e) => setUpdateStartDate(e.target.value)}
                      defaultValue={updateData?.startDate}
                      className="border-1mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                    />{" "}
                    <br />
                  </div>
                  <div className="w-[50%]">
                    <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                      End Date
                    </label>{" "}
                    <br />
                    <input
                      type="date"
                      onChange={(e) => setUpdateEndDate(e.target.value)}
                      defaultValue={updateData?.endDate}
                      className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                    />{" "}
                    <br />
                  </div>
                </div>
                <div className="flex gap-[8px]">
                  <div className="w-[50%]">
                    <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                      Due Date
                    </label>{" "}
                    <br />
                    <input
                      type="date"
                      onChange={(e) => setUpdateDueDate(e.target.value)}
                      defaultValue={updateData?.dueDate}
                      className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                    />{" "}
                    <br />
                  </div>
                  <div className="w-[50%]">
                    <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                      Select Project
                    </label>{" "}
                    <br />
                    <select
                      onChange={(e) => setUpdateSelectProject(e.target.value)} // Update `updateSelectProject` when the selection changes
                      value={updateSelectProject} // Use `updateSelectProject` as the value to stay in sync
                      className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                    >
                      <option value="">- Select Project -</option>
                      {projectDetails.map((project) => (
                        <option key={project.id} value={project.id}>
                          {project.project_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="flex gap-[10px] w-[100%]">
                  <div className="w-[50%]">
                    <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                      Select Department
                    </label>{" "}
                    <br />
                    <select
                      onChange={(e) => setUpdateDepartment(e.target.value)}
                      defaultValue={updateData?.selectDepartmentId}
                      className="border-1 hover:bg-[#fff] mt-1 mr-[0px] mb-[10px] p-[5px] border rounded-md w-full placeholder:font-font-normal text-[#000] text-[12px] xl:text-[14px] focus:outline-none"
                    >
                      <option>Select Department</option>
                      {departments.map((department) => (
                        <option key={department.id} value={department.id}>
                          {department.department_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="w-[50%]">
                    <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                      Task Priority
                    </label>{" "}
                    <br />
                    <select
                      onChange={(e) => setUpdateTaskPriority(e.target.value)} // Update `updateTaskPriority` on selection change
                      value={updateTaskPriority} // Use `updateTaskPriority` as the value to stay in sync
                      className="border-1 hover:bg-[#fff] mt-1 mr-[0px] mb-[10px] p-[5px] border rounded-md w-full placeholder:font-font-normal text-[#000] text-[12px] xl:text-[14px] focus:outline-none"
                    >
                      <option value="">Select Task Priority</option>
                      {taskPriority?.map((priority) => (
                        <option key={priority?.id} value={priority?.id}>
                          {priority?.taskPriorityName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="">
                  <div className="w-[100%]">
                    <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                      Task Assignee
                    </label>{" "}
                    <br />
                  </div>
                  <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                    Task Description
                  </label>
                  <br />
                  <textarea
                    type="text"
                    onChange={(e) => {
                      setUpdateTaskDescription(e.target.value);
                    }}
                    defaultValue={updateData?.taskDescription}
                    className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  />{" "}
                  <br />
                  <div className="w-[100%]">
                    <label className="mb-3 font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                      <SellIcon className="sell-icon" />
                      Task Tag
                    </label>
                    <br />
                    <input
                      type="text"
                      onChange={(e) => {
                        setUpdateTaskTag(e.target.value);
                      }}
                      defaultValue={updateData?.taskTag}
                      className="mt-2 mb-[10px] pr-2 focus:outline-none tag-input"
                      placeholder="Tag"
                    />{" "}
                    <br />
                  </div>
                </div>

                <div>
                  <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                    Attach File
                  </label>
                  <br />
                  <div className="relative">
                    <input
                      type="file"
                      onChange={(e) => setUpdateTaskAttachFile(e.target.value)}
                      className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                    />
                    <button onClick={addNewDiv}>
                      <AddIcon className="plus-icon" />
                    </button>
                  </div>
                </div>

                <div>
                  {/* Dynamically render each div */}
                  {divs.map((_, index) => (
                    <div key={index} className="mb-[10px]">
                      <label className="font-medium text-[13px] xl:text-[14px]">
                        Attach File {index + 1}
                      </label>
                      <br />
                      <div className="relative">
                        <input
                          type="file"
                          className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                        />

                        {/* Remove Button for every div */}
                        <button
                          onClick={() => removeDiv(index)}
                          className="rounded plus-icon"
                        >
                          <RemoveIcon />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
              <button className="first-btn" onClick={closeModal2}>
                Cancel
              </button>
              <button className="second-btn" onClick={updateDataTaskDetails}>
                Confirm
              </button>
            </div>
          </div>
        </Modal>
        {/* onclick Update task */}
      </div>
      {/* Bulk action modal */}
      <Modal open={open} onClose={onCloseModal} center>
        <div className="border-[#dbdbdb] pb-[20px] border-b">
          <h2>Bulk Actions</h2>
        </div>
        <div className="flex items-center gap-[8px] mt-[32px] mb-[30px]">
          <input
            type="checkbox"
            checked={massDelete}
            onChange={handleMassDelete}
          />{" "}
          <p className="text-[14px]">Mass Delete</p>
        </div>

        <div className="w-[100%]">
          <Select
            isMulti
            options={allTaskStatus?.flatMap((status) =>
              status.TaskDetail.map((task) => ({
                value: task.id,
                label: task.taskName,
              }))
            )}
            onChange={handleSelectChangeBulk}
            value={selectedTasks}
            className="basic-multi-select"
            classNamePrefix="select"
            styles={customStyles}
          />
        </div>

        {selectedTasks?.length == 0 ? (
          <p className="mt-[10px] text-[14px] text-[red]">
            if you do not select any groups assigned to the selected customers
            will be removed.
          </p>
        ) : (
          ""
        )}

        <div className="flex justify-end gap-[10px] mt-[24px] pr-[10px] pb-3">
          <button
            className="second-btn"
            onClick={deleteTasksBulk}
            disabled={isLoading}
          >
            {isLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </Modal>
      {/* Bulk action modal end */}
    </div>
  );
};

export default Task;
